var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cms-list"},[_c('data-table',{ref:"table",attrs:{"service":_vm.VoucherService,"entity":_vm.entity,"filters":_vm.filters,"columns":_vm.columns,"disable-permission-checks":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }